module.exports = __webpack_public_path__ + "img/inter12.4eee25f3.jpg";